// extracted by mini-css-extract-plugin
module.exports = {"menu":"ActionsPopup_menu__2iypM","menuItem":"ActionsPopup_menuItem__K6RRF"};